import { useEffect, useRef, useState } from "react";
import { FaTimes } from "react-icons/fa";
import TreeNode from "./list";
import { toastError } from '../../toaster';
import { useAppContextProvider } from '../../../contextapi';

const TOC = (props) => {
  const [tocData, setTocdata] = useState([]);
  const [activeItemId, setActiveItemId] = useState(null);
  const { viewDoc, setSidebarClose } = useAppContextProvider();
  const closeBtnRef = useRef(null);

  useEffect(() => {
    if (viewDoc !== null) {
      TOCFinder(viewDoc.state.doc)
    }
  }, [viewDoc]);

  const TOCFinder = (value) => {
    try {
      const doc = value;
      const lineCount = doc.lines;
      const extractedSections = [];
      const sectionRegex = /\\section\{((?:\\[a-zA-Z]+\{[^}]*\}|[^\\{}])*)\}/g;
      const subsectionRegex = /\\subsection\{((?:\\[a-zA-Z]+\{[^}]*\}|[^\\{}])*)\}/g;
      const subsubsectionRegex = /\\subsubsection\{((?:\\[a-zA-Z]+\{[^}]*\}|[^\\{}])*)\}/g;
      let currentSection = null;
      let currentSubsection = null;
      let hasError = false;

      for (let i = 1; i <= lineCount; i++) {
        try {
          const lineContent = doc.line(i).text;
          let match;

          while ((match = sectionRegex.exec(lineContent)) !== null) {
            currentSection = {
              linenumber: i,
              type: 'section',
              title: match[1].replace(/\\[a-zA-Z]+\{([^}]*)\}/g, '$1'),
              subsections: []
            };
            extractedSections.push(currentSection);
            currentSubsection = null;
          }

          while ((match = subsectionRegex.exec(lineContent)) !== null) {
            if (currentSection) {
              currentSubsection = {
                linenumber: i,
                type: 'subsection',
                title: match[1].replace(/\\[a-zA-Z]+\{([^}]*)\}/g, '$1'),
                subsections: []
              };
              currentSection.subsections.push(currentSubsection);
            }
          }

          while ((match = subsubsectionRegex.exec(lineContent)) !== null) {
            if (currentSubsection) {
              currentSubsection.subsections.push({
                linenumber: i,
                type: 'subsubsection',
                title: match[1].replace(/\\[a-zA-Z]+\{([^}]*)\}/g, '$1'),
                subsections: []
              });
            }
          }
        } catch (error) {
          if (!hasError) {
            toastError(`Error processing line ${i}: ${error.message}`);
          }
        }
      }
      setTocdata(extractedSections);
    } catch (error) {
      toastError(`Error generating table of contents: ${error.message}`);
      setTocdata([]);
    }
  };


  // Focus close button when TOC sidebar is opened
  // useEffect(() => {
  //   // Focus close button when TOC tab is activated
  //   if (props.leftsidebarvalue === 'fileview' && closeBtnRef.current) {
  //     closeBtnRef.current.focus();
  //   }
  // }, [props.leftsidebarvalue]);
   useEffect(() => {    
        if (props.leftsidebarvalue === 'toc') {
                if (closeBtnRef.current) {
                    closeBtnRef.current.focus();
                }
        }
    }, [props.leftsidebarvalue])
  return (
    <div className="toc-area">
      <main className="slider-header">
        <h2>File outline</h2>
        <div>
          <button
            className="close-btn"
            title="Close"
            tabIndex={0}
            ref={closeBtnRef}
            onClick={() => {
              setSidebarClose(true);
              setTimeout(() => {
                const tocBtn = document.getElementById('toc-tab-btn');
                if (tocBtn) tocBtn.focus();
              }, 0);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setSidebarClose(true);
                setTimeout(() => {
                  const tocBtn = document.getElementById('toc-tab-btn');
                  if (tocBtn) tocBtn.focus();
                }, 0);
              }
            }}
          >
            <FaTimes />
          </button>
        </div>
      </main>
      <div className="toc-area-inner">
        <ul className="treenode">
          {tocData.map((item, index) =>
            <TreeNode
              key={item.id || index}
              node={item}
              index={index}
              activeItemId={activeItemId}
              setActiveItemId={setActiveItemId}
              tocData={tocData}
            />
          )}
        </ul>
      </div>
    </div>
  )
}
export default TOC;
